import { useEffect, useState } from "react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useI18n } from "../i18n/I18nContext";
import { api } from "../lib/nailApi";

export default function SponsorsDirectoryPage() {
  const { lang } = useI18n();
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => { api.get("/sponsors/list").then((r) => setSponsors(r.data.sponsors || [])).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-white text-charcoal" data-testid="sponsors-page">
      <SiteHeader variant="light" />
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <p className="text-[11px] uppercase tracking-[0.32em] text-emerald2 font-semibold mb-5">{lang === "en" ? "Sponsor directory" : "Danh mục nhà tài trợ"}</p>
        <h1 className="font-serif text-5xl md:text-6xl text-charcoal">{lang === "en" ? "Sponsors" : "Nhà Tài Trợ"}</h1>
        <p className="mt-4 text-warmgray-700 max-w-2xl">{lang === "en" ? "Brands and partners supporting the Nail Viet Club community." : "Các thương hiệu và đối tác đồng hành cùng cộng đồng Nail Viet Club."}</p>

        {sponsors.length === 0 ? (
          <div className="mt-12 bg-warmgray-50 border border-dashed border-warmgray-300 rounded-3xl p-12 text-center text-warmgray-700">
            {lang === "en" ? "Sponsor directory is growing. Check back soon." : "Danh mục đang được cập nhật."}
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
            {sponsors.map((sp, i) => (
              <a key={i} href={sp.website || "#"} target={sp.website ? "_blank" : "_self"} rel="noopener noreferrer"
                data-testid={`directory-sponsor-${i}`}
                className="bg-white border border-warmgray-200 rounded-3xl p-6 hover:-translate-y-0.5 hover:border-gold-500/40 transition-all">
                <div className="aspect-[3/2] bg-warmgray-50 rounded-2xl flex items-center justify-center mb-4">
                  {sp.logo_url ? <img src={sp.logo_url} alt={sp.name} className="max-h-full max-w-full object-contain" /> : <span className="font-serif text-2xl text-charcoal">{sp.name}</span>}
                </div>
                <div className="font-medium text-charcoal">{sp.name}</div>
                {sp.tier && <div className="text-[10px] uppercase tracking-[0.18em] text-gold-500 font-semibold mt-1">{sp.tier}</div>}
                {sp.description && <p className="mt-2 text-sm text-warmgray-700 line-clamp-3">{sp.description}</p>}
              </a>
            ))}
          </div>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
